export default __webpack_public_path__ + "static/media/nomDeleteIcon.332ca075.svg";